import type { FilterMode } from "./type";
import { createLog } from "../../util/log";

const log = createLog("state");

export const activeConfiguration: {
  mode: FilterMode;
  activeFilterId?: string;
  openFilterIds: Set<string> | null;
  /**
 *
 *
 *
 *
 */
  secondLevelFilterId?: string;
  /**
 *
 */
  allLevelSheet: boolean;
} = $state({
  mode: "default",
  activeFilterId: undefined,
  openFilterIds: null,
  secondLevelFilterId: undefined,
  allLevelSheet: false,
});

/*                                                                                            */
export function setAllLevelSheet(enabled: boolean) {
  activeConfiguration.allLevelSheet = enabled;
}

/**
 *
 *
 *
 *
 *
 */
export function resolveFilterMode(filterId: string | undefined): FilterMode {
  if (activeConfiguration.allLevelSheet && activeConfiguration.secondLevelFilterId !== undefined) {
    return filterId === activeConfiguration.secondLevelFilterId ? "sheetSecondLevel" : "sheetFirstLevel";
  }
  return activeConfiguration.mode;
}

export function setActiveConfiguration(mode: FilterMode, activeFilterId?: string) {
  log.debug("filter configuration mode set", { mode, activeFilterId, previousMode: activeConfiguration.mode });
  activeConfiguration.mode = mode;
  activeConfiguration.activeFilterId = activeFilterId;
}

/**
 *
 *
 *
 */
export function enterSecondLevelFilter(filterId: string) {
  log.debug("second level entered for filter", { filterId, allLevelSheet: activeConfiguration.allLevelSheet });
  activeConfiguration.activeFilterId = filterId;
  activeConfiguration.secondLevelFilterId = filterId;
}

/*                                                                                */
export function exitSecondLevelFilter() {
  log.debug("second level exited for filter", { filterId: activeConfiguration.secondLevelFilterId });
  activeConfiguration.secondLevelFilterId = undefined;
  activeConfiguration.activeFilterId = undefined;
}

export function setOpenFilterIds(filterIds: string[]) {
  log.debug("open filter ids set", { filterIds });
  activeConfiguration.openFilterIds = new Set(filterIds);
}

export function toggleFilterAccordion(filterId: string, isOpen: boolean) {
  log.debug("filter accordion toggled", { filterId, isOpen });
  const next = new Set(activeConfiguration.openFilterIds ?? []);
  if (isOpen) {
    next.add(filterId);
  } else {
    next.delete(filterId);
  }
  activeConfiguration.openFilterIds = next;
}
